import { Card, CardContent, Typography, Box } from "@mui/material";
import { BIGrey } from "../assets/helpers";
import { useNavigate } from "react-router-dom";

export const Ads = ({ ad }) => {
  const navigate = useNavigate();

  function getSafeUrl(rawUrl) {
    if (!rawUrl) return null;

    return rawUrl.startsWith("http://") || rawUrl.startsWith("https://")
      ? rawUrl
      : `https://${rawUrl}`;
  }

  function handleAdClick(clickFrom) {
    console.log("Ad clicked:", clickFrom);
    if (!clickFrom) return;

    if (clickFrom?.title === "CD Ads") {
      switch (clickFrom?.redirectUrl) {
        case "tickets":
        case "Tickets":
          navigate("/tickets");
          break;
        case "MySites":
        case "MySites1":
        case "Sites":
        case "sites":
          navigate("/sites");
          break;
        case "Quiz":
          navigate("/reward-store/earn-builderbucks");
          break;
        case "Carpool":
          navigate("/carpool");
          break;
        case "Expenses":
          navigate("/expenses");
          break;
        case "RewardStore":
          navigate("/reward-store");
          break;
        default: {
          const safeUrl = getSafeUrl(clickFrom.redirectUrl);
          if (safeUrl) window.open(safeUrl, "_blank");
          break;
        }
      }
    } else if (clickFrom?.title === "Marketing Ads") {
      const safeUrl = getSafeUrl(clickFrom.redirectUrl);
      if (safeUrl) window.open(safeUrl, "_blank");
    }
  }

  return (
    <Card
      onClick={() => handleAdClick(ad)}
      sx={{
        cursor: ad?.redirectUrl ? "pointer" : "default",
        borderRadius: 1,
        boxShadow: 1,
        overflow: "hidden"
        // mb: 1,
      }}>
      <CardContent
        sx={{
          p: 1,
          display: "flex",
          flexDirection: "column",
          gap: 1,
          "&:last-child": {
            paddingBottom: "10px"
          }
        }}>
        {ad?.description && (
          <Typography
            variant="body1"
            sx={{
              color: BIGrey,
              fontWeight: 500
            }}>
            {ad.description}
          </Typography>
        )}

        {ad?.fileUrl && (
          <Box
            component="img"
            src={ad.fileUrl}
            alt="Advertisement"
            loading="lazy"
            sx={{
              width: "100%",
              height: "auto",
              borderRadius: 2,
              objectFit: "cover"
            }}
          />
        )}
      </CardContent>
    </Card>
  );
};
